import React, {useEffect, useState} from 'react';
import { useScript } from "@uidotdev/usehooks";
import {jwpUrl} from "../util/mediaPlayer";
import {isEmpty} from "../util";
import {cloneDeep} from "lodash";
import {commonAPI} from "../api/commonAPI";

export const usePlayJwp = (props:any) => {
    const status = useScript(jwpUrl, {
        removeOnUnmount: false,
    });
    const [view, setView] = useState(false);
    const getMedia = async (id:any) => {
        if(isEmpty(props?.id)) return;
        await commonAPI.getJwpToken(id)
            .then(async res => {
                const list = await res?.data?.playlist
                if(!isEmpty(list)){
                    playMedia(cloneDeep(list));
                };
            });
    };
    const playMedia = (playList:any) => {
        if(!isEmpty(playList)){
            try {
                window.jwplayer('jwplayer').setup({
                    playlist:cloneDeep(playList),
                });
            }catch (e) {
                console.log("@e",e);
            };
        };
    };
    useEffect(() => {
        getMedia(props?.id);
    }, [status, props?.id]);
    return {status, view};
};

